module.exports = __webpack_public_path__ + "fonts/SEBSansSerif-Light.5ec81e87.woff";